// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登錄
// 首页
import index from '@/views/index';

import Home from '@/views/home/index';
import Pro from '@/views/home/pro';
import history from '@/views/home/history';
import Recommend from '@/views/home/recommend';
import Clients from '@/views/home/clients';
import Contact from '@/views/home/contact';


import MyHome from '@/views/user/Index';
import Bookings from '@/views/user/Bookings';
import Booknow from '@/views/user/Booknow';
/**
 * 基础菜单
 */

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    mode: 'history',
    base:'/',
    routes: [{
        path: '/',
        name: '主頁',
        redirect: '/index',
        component: index,
        meta: {
            title:'主頁｜NOMOMO',
            keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
            description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
            requireAuth: false
        },
        children: [{
            path: '/index',
            name: '主頁',
            component: Home,
            meta: {
                title:'主頁｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        },{
            path: '/price',
            name: '價目表',
            component: Pro,
            meta: {
                title:'價目表｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        }
        ,{
            path: '/story',
            name: '品牌故事',
            component: history,
            meta: {
                title:'品牌故事｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        }
        ,{
            path: '/product',
            name: '美肌教室',
            component: Recommend,
            meta: {
                title:'美肌教室｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        }
        ,{
            path: '/review',
            name: '客人評價',
            component: Clients,
            meta: {
                title:'客人評價｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        }
        ,{
            path: '/contact',
            name: '聯絡我們',
            component: Contact,
            meta: {
                title:'聯絡我們｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: false
            }
        },
        {
            path: '/user/Index',
            name: 'My Home',
            component: MyHome,
            hidden: true,
            meta: {
                title:'My Home｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: true
            }
        },
        {
            path: '/user/Bookings',
            name: 'My Bookings',
            component: Bookings,
            hidden: true,
            meta: {
                title:'My Bookings｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: true
            }
        }
    
        ,
        {
            path: '/user/Booknow',
            name: 'Bookings',
            component: Booknow,
            hidden: true,
            meta: {
                title: 'Bookings｜NOMOMO',
                keywords:'每天約滿，先看看我的故事💐瘋狂店主Cony，碩士畢業生，因不喜歡美容業Hard Sell風氣，放棄穩定收入工作，低調轉行進軍美容界，創辦單次現金收費激光脫毛及皮秒淡斑良心小店。',
                description:'單次收費、激光脫毛、皮秒淡斑、良心小店',
                requireAuth: true
            }
        }]
    }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js